window.addEventListener("DOMContentLoaded", ()=>{
    // const navToggle = document.getElementById('toggle-navigation')
    const navTarget = document.getElementById('site-header')

    // navToggle.addEventListener('click', ()=>{
    //     navTarget.dataset.toggled = ("false" == navTarget.dataset.toggled) ? "true" : "false"
    // })

    window.addEventListener('resize', ()=>{
        if("false" != navTarget.dataset.toggled) {
            navTarget.dataset.toggled = "false"
        }
    })
})